import { styled } from '@/styled-system/jsx';

export const PoweredByZillowBadgeIcon = styled('img', {
  base: {
    marginLeft: '4px',
    paddingBottom: '5px',
  },
});
